import React, { useState } from 'react';
import './GarmentColorPicker.css';

const SWATCHES = [
  { label: 'White',      value: '#FFFFFF', border: '#d1d5db' },
  { label: 'Black',      value: '#111111', border: '#374151' },
  { label: 'Cream',      value: '#FEF3C7', border: '#d97706' },
  { label: 'Navy',       value: '#1e3a5f', border: '#1e40af' },
  { label: 'Terracotta', value: '#C0704A', border: '#9a3412' },
];

export default function GarmentColorPicker({ selected, onChange }) {
  const [hoveredIdx, setHoveredIdx] = useState(null);

  return (
    <div className="garment-color-picker">
      <span className="garment-color-label">Preview on:</span>
      <div className="garment-color-swatches">
        {SWATCHES.map((sw, i) => (
          <button
            key={sw.value}
            className={`garment-swatch${selected === sw.value ? ' active' : ''}`}
            style={{
              background: sw.value,
              borderColor: selected === sw.value ? sw.border : 'transparent',
              boxShadow: selected === sw.value
                ? `0 0 0 3px ${sw.border}55, 0 2px 8px ${sw.value}88`
                : hoveredIdx === i
                  ? `0 0 0 2px ${sw.border}88`
                  : 'none',
            }}
            title={sw.label}
            aria-label={`${sw.label} background`}
            onClick={() => onChange(sw.value)}
            onMouseEnter={() => setHoveredIdx(i)}
            onMouseLeave={() => setHoveredIdx(null)}
          >
            {selected === sw.value && (
              <span
                className="garment-swatch-check"
                style={{ color: sw.value === '#FFFFFF' || sw.value === '#FEF3C7' ? '#333' : '#fff' }}
              >
                ✓
              </span>
            )}
          </button>
        ))}
      </div>
      {hoveredIdx !== null && (
        <span className="garment-color-tooltip">{SWATCHES[hoveredIdx].label}</span>
      )}
    </div>
  );
}
